import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationMenuCategoryActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/MenuCategory/MenuCategoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationMenuCategory"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationMenuCategory"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationMenuCategoryActivity)
